import { useFormContext } from 'react-hook-form'

import { FormError, SearchSelect } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

export interface ClientIdFormFieldProps {
  clients?: { label: string; value: number }[]
  loading?: boolean
}

export const ClientIdFormField: React.FC<ClientIdFormFieldProps> = ({ clients, loading }) => {
  const { control, setValue } = useFormContext<{ client_id: number | null }>()

  return (
    <FormField
      name="client_id"
      control={control}
      render={({ field }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Client</FormLabel>
              <FormError />
            </div>
            <SearchSelect
              placeholder={'Select a Client'}
              loading={loading}
              value={field.value?.toString()}
              setValue={(val) =>
                setValue('client_id', val ? parseInt(val) : null, {
                  shouldValidate: true,
                })
              }
              options={clients?.map(({ label, value }) => ({ label, value: value?.toString() }))}
            />
          </FormItem>
        )
      }}
    />
  )
}
